import { Injectable } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, empty, of, throwError, Subscription } from 'rxjs';
import { catchError, map, mergeMap, switchMap, withLatestFrom, distinctUntilChanged } from 'rxjs/operators';

import * as Objects from '@core/objects';

import * as Access from '@app/models/access';
import * as Search from '@app/models/search';

import { LibraryRequests } from './library.requests';

import * as fromStore from './library.state';
import * as fromActions from './library.actions';
import { VersionFeedbackStatus, ApprovalStatusCodeEnum, FeedbackStatusCodeEnum, FeedbackStatusTextEnum } from '@core/models/version-feedback';
import { VersionShareItem } from '@core/models/version-share.model';


@Injectable()
export class LibraryEffects {

    constructor(private actions$: Actions, private store$: Store<fromStore.Library>, private requests: LibraryRequests) {}

    
    public init$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.Init>(fromActions.LibraryActionType.Init),
         //withLatestFrom(this.store$.select(fromStore.usersGetAllUsersSelector)),
        switchMap((action) => {
            // console.log(" initttttt ",action)
            return [
            new fromActions.LoadFilters(),
            new fromActions.LoadResults()
        ]})
    ));

    // public initVersionsStatusAccess$ = createEffect(() => this.actions$.pipe(
    //     ofType<fromActions.InitVersionStatusAccess>(fromActions.LibraryActionType.InitVersionStatusAccess),
    //      //withLatestFrom(this.store$.select(fromStore.usersGetAllUsersSelector)),
    //     switchMap((action) => {
    //         console.log(" initttttt version statuss access ",action)
    //         return [
    //         new fromActions.LoadVersionsStatusAccess()
    //     ]})
    // ));

    // this load the version status access list
    public loadVersionStatusAccess$: Observable<fromActions.LibraryActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadVersionsStatusAccess>(fromActions.LibraryActionType.LoadVersionsStatusAccess),
        switchMap((action) => {
            return this.requests.getVersionStatusAccess$().pipe(
                map((versionStatusAccess: Access.AccessVersionStatus[]) => {
                    return new fromActions.LoadVersionsStatusAccessSuccess(versionStatusAccess);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.LoadVersionsStatusAccessError(err));
                })
            );
        })
    ));
    
    public loadFilters$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadFilters>(fromActions.LibraryActionType.LoadFilters),
         //withLatestFrom(this.store$.select(fromStore.usersGetAllUsersSelector)),
        switchMap((action) => [
            new fromActions.LoadFilterLabels(),
            new fromActions.LoadFilterStatus()
        ])
    ));

    
    public loadFilterLabels$: Observable<fromActions.LibraryActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadFilterLabels>(fromActions.LibraryActionType.LoadFilterLabels),
        switchMap((action) => {
            return this.requests.filterLabels$().pipe(
                map((labels: Objects.Label[]) => {
                    // console.log(" labelssss ",labels)
                    return new fromActions.LoadFilterLabelsSuccess(labels);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.LoadFilterLabelsError(err));
                })
            );
        })
    ));

    
    public loadFiltersLabelsSuccess$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadFilterLabelsSuccess>(fromActions.LibraryActionType.LoadFilterLabelsSuccess),
        withLatestFrom(this.store$.select(fromStore.librarySelector)),
        switchMap(([action, library]) => [
            new fromActions.PushSearchFilters(Search.SearchConvert.filtersFromParams(library.search_query_params, library.available_filters.labels)),
        ])
    ));

    // this load the version status list
    public loadFilterStatus$: Observable<fromActions.LibraryActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadFilterStatus>(fromActions.LibraryActionType.LoadFilterStatus),
        switchMap((action) => {
            return this.requests.filterStatus$().pipe(
                map((status: Objects.Status[]) => {
                    return new fromActions.LoadFilterStatusSuccess(status);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.LoadFilterStatusError(err));
                })
            );
        })
    ));

    
    public loadFiltersStatusSuccess$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadFilterStatusSuccess>(fromActions.LibraryActionType.LoadFilterStatusSuccess),
        withLatestFrom(this.store$.select(fromStore.librarySelector)),
        switchMap(([action, library]) => [
            new fromActions.PushSearchFilters(Search.SearchConvert.filtersFromParams(library.search_query_params, library.available_filters.status)),
        ])
    ));

    
    public setSearchTerm$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.SetSearchTerm>(fromActions.LibraryActionType.SetSearchTerm),
        // withLatestFrom(this.store$.select(fromStore.searchFiltersSelector)),
        switchMap((action) => [
            // new fromActions.UpdateSearchQuery()
            new fromActions.UpdateQueryParams()
        ])
    ));

    
    public applySearchFilter$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.ApplySearchFilter>(fromActions.LibraryActionType.ApplySearchFilter),
        // withLatestFrom(this.store$.select(fromStore.searchFiltersSelector)),
        switchMap((action) => [
            // new fromActions.UpdateSearchQuery()
            new fromActions.UpdateQueryParams()
        ])
    ));

    
    public removeSearchFilter$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.RemoveSearchFilter>(fromActions.LibraryActionType.RemoveSearchFilter),
        // withLatestFrom(this.store$.select(fromStore.searchFiltersSelector)),
        switchMap((action) => [
            // new fromActions.UpdateSearchQuery(),
            new fromActions.UpdateQueryParams()
        ])
    ));

    
    public updateQueryParams$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateQueryParams>(fromActions.LibraryActionType.UpdateQueryParams),
        withLatestFrom(this.store$.select(fromStore.searchSelector)),
        switchMap(([action, search]) => {
            // let convert = new Search.SearchConvert();
            return [
                new fromActions.SetQueryParams(Search.SearchConvert.paramsFromFilters(search.filters, search.term, search.sort)),
            ]
        })
    ));
    
    public setQueryParams$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.SetQueryParams>(fromActions.LibraryActionType.SetQueryParams),
        // withLatestFrom(this.store$.select(fromStore.searchFiltersSelector)),
        switchMap((action) => {
            // we need to clear the feedbacks to match the new versions loaded. Versions are never repeated in call.
            let setqEvents = []
            setqEvents.push(new fromActions.ClearVersionFeedbacks());
            setqEvents.push(new fromActions.LoadResults());
            return setqEvents;
        })
    ));

    
    public loadResultItems$: Observable<fromActions.LibraryActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadResults>(fromActions.LibraryActionType.LoadResults),
        withLatestFrom(this.store$.select(fromStore.librarySelector)),
        switchMap(([action, library]) => {
            return this.requests.results$(Search.SearchConvert.removeVoidParams(library.search_query_params), library.results.next_page, library.search.limit, null).pipe(
                map((versions: Objects.Version[]) => {
                    return new fromActions.LoadResultsSuccess(versions);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.LoadResultsError(err));
                })
            );
        })
    ));

    // TODO: here should call all pages in case we have more than one page loaded, this way we keep the screen updated
    public reloadResults$: Observable<fromActions.LibraryActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.ReloadResults>(fromActions.LibraryActionType.ReloadResults),
        // withLatestFrom(this.store$.select(fromStore.resultItemsSelector)),
        switchMap((action) => [
            new fromActions.LoadResults()
        ])
    ));

    
    public updateVersion$: Observable<fromActions.LibraryActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateVersion>(fromActions.LibraryActionType.UpdateVersion),
        withLatestFrom(this.store$.select(fromStore.resultItemsSelector)),
        mergeMap(([action, versions]) => {
            let events = [];
            if (versions.filter((version: Objects.Version) => version.id == action.versionId).length > 0)
                events.push(new fromActions.ReloadResults());
            
            return events;
        })
    ));

    public setVersionStatus$ = createEffect(() => this.actions$.pipe(
        ofType<fromActions.SetVersionStatus>(fromActions.LibraryActionType.SetVersionStatus),
        // withLatestFrom(this.store$.select(fromStore.versionSelector)),
        switchMap((action) => {
            return this.requests.setVersionStatus$(action.versionId, action.status).pipe(
                map((version: Objects.Version) => {
                    return new fromActions.SetVersionStatusSuccess(version);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.SetVersionStatusError(err));
                })
            );
          
        })
    ));

    public loadResultsSuccess$: Observable<fromActions.LibraryActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.LoadResultsSuccess>(fromActions.LibraryActionType.LoadResultsSuccess),
        switchMap((action) => {

            let events = [];
            // just call to lod feedbacks when we have at least one version on results
            if (action.versions.length > 0){
                events.push(new fromActions.LoadVersionFeedbacks(action.versions));
            }
            return events;
        })
    ));

    public loadResultFeedbacks$: Observable<fromActions.LibraryActions> = createEffect(() =>  this.actions$.pipe(
        ofType<fromActions.LoadVersionFeedbacks>(fromActions.LibraryActionType.LoadVersionFeedbacks),
        withLatestFrom(this.store$.select(fromStore.librarySelector)),
        // oct-2026: mergeMap, not switchMap: each page asks for the bubbles of different versions, so a new
        // page must not cancel the previous one (the browser cancels it, but the backend still processes it)
        mergeMap(([action,library]) => {
            // check the access to call feedbacks according access set in Init action. 
            if(library.version_feedbacks.feedbackAccess == null || library.version_feedbacks?.feedbackAccess == false)
                return [];
            return this.requests.getVersionShareItems$(action.versions).pipe(
                map((feedbacks: VersionShareItem[]) => {
                    if(action.versions.length == 1 && feedbacks.length == 0 ){
                        // When one version and no feedbcaks we need to empty the current feedbcaks for the version in teh acton versions
                        return new fromActions.LoadVersionEmptyFeedbacksSuccess(action.versions);
                    }
                    // normal update feedbacks list removing current for the feedbacks versions and putting the new ones.
                    return new fromActions.LoadVersionFeedbacksSuccess(feedbacks);
                }),
                catchError((err: any) => {
                    console.log(err);
                    throwError(() => err);
                    return of(new fromActions.LoadVersionFeedbacksError(err));
                })
            );
        })
    ));

    // WS events update version feedbcask by id
    public updateVersionFeedbacks$: Observable<fromActions.LibraryActions> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateVersionFeedbacks>(fromActions.LibraryActionType.UpdateVersionFeedbacks),
        withLatestFrom(this.store$.select(fromStore.resultItemsSelector)),
        mergeMap(([action, versions]) => {
            let events = [];
            if(versions){
                const versionsAlreadyLodaded = versions.filter((version: Objects.Version) => version.id == action.versionId);
                // return LoadVersionFeedbacks only when the version is on the list
                if(versionsAlreadyLodaded?.length > 0){
                    events.push(new fromActions.LoadVersionFeedbacks(versionsAlreadyLodaded));
                }
            }
            return events;
        })
    ));


    /**
     * @deprecated once we have status always when we set feedbacks
     */
    // public loadVersionFeedbacksPreSuccess$: Observable<fromActions.LibraryActions> = createEffect(() => this.actions$.pipe(
    //     ofType<fromActions.LoadVersionFeedbacksPreSuccess>(fromActions.LibraryActionType.LoadVersionFeedbacksPreSuccess),
    //     switchMap((action) => {
    //         let newStatus: VersionFeedbackStatus;
    //         let feedbacks = action.feedbacks.map((fv: VersionShareItem) => {
    //             // check if we have feedback status, if not then check approval
    //             if(fv?.status == null){
    //                 // set new default status
    //                 newStatus = {date:'',status_code : FeedbackStatusCodeEnum.OPENED_CODE, status_text: FeedbackStatusTextEnum.OPENED_TEXT};
    //                 // check approval not null
    //                 if(fv.approval != null){
    //                     newStatus = {
    //                         date:  fv.approval.date,
    //                         status_code: (fv.approval.status_code != ApprovalStatusCodeEnum.PENDING_CODE) ? 
    //                             FeedbackStatusCodeEnum.CLOSED_CODE : FeedbackStatusCodeEnum.OPENED_CODE,
    //                         status_text: (fv.approval.status_code != ApprovalStatusCodeEnum.PENDING_CODE) ? 
    //                             FeedbackStatusTextEnum.CLOSED_TEXT : FeedbackStatusTextEnum.OPENED_TEXT
    //                     }
    //                 }
    //                 // if approval is null && status null new status is the previous set as open.
    //                 return {...fv, status: newStatus};
    //             } else {
    //                 return fv;
    //             }
    //         });
    //         return [new fromActions.LoadVersionFeedbacksSuccess(feedbacks)];
    //     })
    // ));
    
}
